function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGraph = function SvgGraph(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    stroke: "#000",
    style: {
      transform: "scale(-1,1)"
    },
    viewBox: "0 0 32 32"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M285 148c0 63.5-51.5 115-115 115S55 211.5 55 148 106.5 33 170 33s115 51.5 115 115ZM285 658c0 63.5-51.5 115-115 115S55 721.5 55 658s51.5-115 115-115 115 51.5 115 115ZM796 402c0 63.5-51.5 115-115 115s-115-51.5-115-115 51.5-115 115-115 115 51.5 115 115Zm0 0",
    style: {
      strokeWidth: 50,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    transform: "translate(3.438 3.156)scale(.03125)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m291.5 208.5 257.625 128",
    style: {
      strokeWidth: 50,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    transform: "translate(3.438 3.156)scale(.03125)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m298.5 466.976 256.625 127.5",
    style: {
      strokeWidth: 50,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    transform: "matrix(.03125 0 0 -.03125 3.438 36.327)"
  }));
};
export default SvgGraph;